import { useCustomizationStore } from '../stores/customizationStore';
import { getItemById } from '../utils/items';

export function useStoreItem(itemId: number | undefined) {
    const { storeItems } = useCustomizationStore();
    if (!itemId) return null;
    return getItemById(itemId, storeItems);
}
